import { SxProps, Theme } from '@mui/material';

export const headerLocateStoreSX: Record<string, SxProps<Theme>> = {
	container: {
		p: '15px 20px',
	},
};
